module.exports = __webpack_public_path__ + "img/蒙版组 2@2x.e5b48ef0.webp";